import DataObjectField from "@/utilities/classes/data-object-field";

const buildCreateMIHTenantObject = (CurrTenant, relatedProject, TaxReturnFile, TaxReturnName, IDFile, IDName, CreditReportFile, CreditReportName, ZeroIncomeCertFile, ZeroIncomeCertName) => {

    const fields = [
    new DataObjectField(CurrTenant.FirstName, 6),
    new DataObjectField(CurrTenant.LastName, 7),
    new DataObjectField(CurrTenant.Race, 8),
    new DataObjectField(CurrTenant.Ethnicity, 9),
    new DataObjectField(CurrTenant.DateOfBirth, 10),
    new DataObjectField(relatedProject, 17),
    {
        _fid: "15",
        _filename: CreditReportName,
        __text: CreditReportFile,
    },
    {
        _fid: "16",
        _filename: IDName,
        __text: IDFile,
    },
    {
        _fid: "21",
        _filename: TaxReturnName,
        __text: TaxReturnFile,
    },
    {
        _fid: "22",
        _filename: ZeroIncomeCertName,
        __text: ZeroIncomeCertFile,
    },
  ];

  const dataObject = {
    qdbapi: {
      udata: "SHARC_CREATE_MIH_TENANT",
      apptoken: "dsgdzckckic6iabhuap3kdyiwdgc",
      clist: "3",
      field: fields
    }
  };
  return dataObject;
};

export default buildCreateMIHTenantObject;